import { useState } from "react";
import Dialog from "@/components/react/Dialog";
import Input from "@/components/react/Input";
import useI18n from "@/hooks/useI18n";
import { css, cx } from "@styled-system/css";
import { Box, Flex } from "@styled-system/jsx";
import { button } from "@styled-system/recipes";
import { sendy } from "@/api/sendy";

export default function NewsletterDialog({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  const [email, setEmail] = useState("");
  const [actionStatus, setActionStatus] = useState<"success" | "error" | null>(null);
  const { t, locale } = useI18n();

  const isCzech = locale === "cs";

  const handleSubscribe = async () => {
    const res = await sendy.subscribe(email, sendy.getListKeys<"barkio">().sa);
    if (res) setActionStatus("success");
    else setActionStatus("error");
  };

  return (
    <Dialog
      title={isCzech ? "Získejte ebook o separační úzkosti psů" : "Get dog separation anxiety ebook"}
      subtitle={
        isCzech
          ? "Získejte zdarma ebook o separační úzkosti psů, kterou si můžete později přečíst"
          : "Get a free dog separation anxiety ebook to read later"
      }
      isOpen={isOpen}
      onClose={onClose}
      closeButton
      variant={{ sa: "newsletter" }}
    >
      <Box
        className={css({
          position: "absolute",
          left: "0",
          top: "0",
          transform: "translate(-60%, -60%)",
          borderRadius: "100%",
          width: "233px",
          height: "233px",
          bg: "tint2"
        })}
      />
      <Box
        className={css({
          position: "absolute",
          right: "0",
          bottom: "0",
          transform: "translate(50%, 65%)",
          borderRadius: "100%",
          width: "233px",
          height: "233px",
          bg: "primary"
        })}
      />
      <Flex justifyContent="center" mb="72px">
        <Flex alignItems="center" m="32px" maxWidth="420px">
          {actionStatus && (
            <>
              {actionStatus === "success" && <p className={css({ color: "primary" })}>{t("newsletter.success")}</p>}
              {actionStatus === "error" && <p className={css({ color: "warning" })}>{t("newsletter.error")}</p>}
            </>
          )}
          {!actionStatus && (
            <Flex flexDir={["column", "row"]} gap={["1rem", 0]}>
              <Input
                attributes={{
                  required: true,
                  onChange: ({ target }) => setEmail(target.value),
                  type: "email",
                  value: email
                }}
                label={t("newsletter.email")}
              />
              <button className={cx(button({ variant: "filled" }), css({ ml: [0, "1rem"] }))} onClick={handleSubscribe}>
                {isCzech ? "Získejte ebook" : "Get ebook"}
              </button>
            </Flex>
          )}
        </Flex>
      </Flex>
    </Dialog>
  );
}
